

/// <reference path="Intermediary.ts" />

// Generated class Distributor_ManagedObject

class Distributor_ManagedObject extends Intermediary
{
}
